// Load dayjs, plugins and language packs.
import dayjs from 'dayjs-ext'

import timeZonePlugin from 'dayjs-ext/plugin/timeZone'
import customParseFormat from 'dayjs-ext/plugin/customParseFormat'
import localizableFormat from 'dayjs-ext/plugin/localizableFormat'
import relativeTime from 'dayjs-ext/plugin/relativeTime'
 

dayjs.extend(timeZonePlugin)
     .extend(customParseFormat)
     .extend(localizableFormat)
     .extend(relativeTime)
 
export default dayjs